/**
 * Deferred rich-text images (snippets/rte-lazy.liquid with `defer: true`).
 *
 * The product description's pictures keep their address in data-src / data-srcset so they cannot
 * race the product photo for a phone's bandwidth. Once the page has loaded, each picture gets its
 * address back when the reader is within about a screen of it (or at once where
 * IntersectionObserver is missing).
 */
const MARGIN = '900px 0px';

/** @param {HTMLImageElement} image */
function restore(image) {
  const { src, srcset } = image.dataset;
  if (srcset) image.setAttribute('srcset', srcset);
  if (src) image.setAttribute('src', src);
  delete image.dataset.src;
  delete image.dataset.srcset;
  image.removeAttribute('data-rte-defer');
}

function start() {
  // Tells the inline safety net in snippets/rte-lazy.liquid that this script is running.
  window.__bkRteDefer = true;
  const images = [...document.querySelectorAll('img[data-rte-defer]')].filter((image) => image instanceof HTMLImageElement);
  if (images.length === 0) return;
  if (!('IntersectionObserver' in window)) {
    images.forEach(restore);
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        restore(/** @type {HTMLImageElement} */ (entry.target));
      }
    },
    { rootMargin: MARGIN }
  );
  images.forEach((image) => observer.observe(image));
}

if (document.readyState === 'complete') start();
else window.addEventListener('load', start, { once: true });
